(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
//globals, shims and polyfils
var WtcpJs = WtcpJs || {};

if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

if (!Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}

if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (target) {
            'use strict';
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert first argument to object');
            }

            var to = Object(target);
            for (var i = 1; i < arguments.length; i++) {
                var nextSource = arguments[i];
                if (nextSource === undefined || nextSource === null) {
                    continue;
                }
                nextSource = Object(nextSource);

                var keysArray = Object.keys(Object(nextSource));
                for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
            return to;
        }
    });
}
},{}],2:[function(require,module,exports){
(function(wtcpJs) {
    "use strict";
    class ErrorResponse {
        constructor() {
            this.errorCode = 0;
            this.errorMessage = "";
        }
    }

    wtcpJs.ErrorResponse = ErrorResponse;
})(WtcpJs || (WtcpJs = {}));
},{}],3:[function(require,module,exports){
(function (wtcpJs) {
    "use strict";
    class AnchorInfo {

        constructor() {
            this.value = 0;
            this.type = 0;
            this.before = 0;
            this.after = 0;
        }
    }

    wtcpJs.AnchorInfo = AnchorInfo;
})(WtcpJs || (WtcpJs = {}));
},{}],4:[function(require,module,exports){
(function(wtcpJs) {
    "use strict";
    let guid = require('guid');
    class PrivateTextMessageRequest {
        constructor(obj) {
            this.conversationId = "";
            this.label = "";
            this.participants = [];
            this.metaData = [];
            this.mimeType = 'text/plain; charset=utf8';
            this.data = ''; 
            this.destination = {
                userName: '', 
                displayName: '', 
                callAlias: '' 
            };

            if(!obj || !obj.conversationId)
            {
                this.conversationId = guid.create().value;
            } else {
                this.conversationId = obj.conversationId;
            }
        }
    }

    wtcpJs.PrivateTextMessageRequest = PrivateTextMessageRequest;
})(WtcpJs || (WtcpJs = {}));
},{"guid":9}],5:[function(require,module,exports){
(function (global){(function (){
/// <reference path="/js/libs/hmac-md5.js" />
/// <reference path="/js/libs/wtcp.util.js" />
/// <reference path="/js/libs/wtcp.locator.js" />

const wtcpUtil = require('./wtcp.util.js');

global.WtcpJs = global.WtcpJs || {};

(function (wtcp) {
    "use strict";

    var util = require('./wtcp.util.js');
    var resp = require('./wtcp-types/ErrorResponse.js');
    var ai = require('./wtcp-types/requests/AnchorInfo.js');
    var pmReq = require('./wtcp-types/requests/PrivateTextMessageRequest.js');
    var audio = require('./wtcp.wtcpaudio.js');
    var locService = require('./wtcp.locator.js');
    var uaParser = require('ua-parser-js');

    const WTCPJS_CLIENT_OFFSET = 0x1B58;

    var eventList = {
        PROXY_UPDATED: "pu1",
        CHANNEL_PROPS_RECEIVED: "cp1",
        CHANNEL_ACTIVITY: "ca1",
        ENDPOINT_PROPS_RECEIVED: "ep1",
        PTT_OFF: "po1",
        DTMF_RECEIEVED: "dr1",
        CALL_PTT_ON_RECEIVED: "cpor1",
        CALL_PTT_OFF_RECEIVED: "cpor2",
        TXT_MSG_RECEIVED: "tm1",
        OPEN_SESSION_RECEIVED: "sr1",
        SESSION_CLOSED_RECEIVED: "scr1",
        PING_PONG_RESPONSE: "ppr",
        SOCKET_CLOSED: "sc1",
        SIGNAL_RECEIVED: "sr2",
        PHONE_LINE_STATUS_CHANGED: "plsc",
        CALL_PROGRESS_RECEIVED: "cpr",
        CALL_HANGUP_RECEIVED: "chr",
        CALL_OFFER_RECEIVED: "cor",
        CONNECTION_INFO_UPDATED: "lu",
        PRIV_MEDIA_MSG_RECEIVED: "pmmr"
    };

    var proxyInstanceCnt = 0;
    var proxyGlobals = {};
    var transCounter = 0; // transaction counter 1..36767

    var wtcpJsClientErrors = {
        "PTT_NOT_READY": (() => {
            let err = new WtcpJs.ErrorResponse();
            err.errorCode = WTCPJS_CLIENT_OFFSET | 1;
            err.errorMessage = "You cannot PTT again until the WtpcjJs client handles the PTTUp response";

            return err;
        })()
    };

    var registerInstance = function registerInstance() {
        var id = "proxy_instance_" + proxyInstanceCnt++;
        proxyGlobals[id] = {};

        return id;
    };

    var pushCallbacks = function pushCallbacks(map, res, rej) {
        // use transaction counter as a key for the map 
        // use one counter for all maps (don't need to have individual counter for every map) 
        // some leftover key will be gone after one cycle loop due to a missing response
        transCounter = (transCounter + 1) % 36768; 
        // valid transaction range is [1..36767] 
        if(transCounter == 0) transCounter = 1; 
        map.set(transCounter,{ resolve: res, reject: rej })
        return transCounter; 
    };

    var getCallback = function getCallback(map, key) {
        var cb;
        if (!map.has(key)) {
            if (map.size > 0)  { // pick the last one -- this is a bad code smell (bug 46475) it appears that unit test will make this bad situation.
                wtcpUtil.wtcpInfo(`ALERT: number of keys : ${map.size} map = ${map.toString()}`);
                for(let k of map.keys())
                    key = k;
                wtcpUtil.wtcpInfo("ALERT: Fetch the last key instead for given key:", key)
            }
        }
        // if key is still missing, return undefined 
        cb = map.get(key);
        map.delete(key)
        return cb; 
    };

    var ua = null;
    if(window && window.navigator) {
        ua = uaParser(navigator.userAgent);
    }

    wtcp.Client = function (clientOptions, clientWorker) {

        if (!(this instanceof wtcp.Client)) return new wtcp.Client(clientOptions);

        /* --- Private variables --- */

        var local = {};
        var defaults = {
            profileId: "",
            pingInterval: 30,
            initialVolume: 100,
            audioPlayerActive: true,
            loggingLevel: 0,
            exportOutboundAudio: false,
            processorNodeBufferSize: 8192,
            outboundAudioFile: 'audio.wav',
            deviceId: "HTML5 capable browser",
            applicationName: 'MOT-WTCPJS-1.1',
            licenseUUID: "{436C743D-896D-456e-A61B-6F564F3D2C78}" // default to WAVE_LICENSE_WTC_SDK
        };

        var socketActive = false;
        var locator;
        var serverUrlPattern = /^ws{1,2}:\/\//;
        var httpsPattern = /^https:\/\//;
        var settings = {};
        var pttDownPending = false;
        var pttUpPending = false;
        var pttUpSuccess = null;
        var pttUpFailure = null;
        var pttOn = false;
        var requestTimeoutId;

        var callbacks = {
            socketConnectedCallbacks: new Map(),
            sendCredentialsCallbacks: new Map(),
            getChannelPropsCallbacks: new Map(),
            setChannelPropsCallbacks: new Map(),
            getEndpointLookupCallbacks: new Map(),
            getEndpointPropsCallbacks: new Map(),
            setEndpointPropsCallbacks: new Map(),
            setActiveChannelsCallbacks: new Map(),
            setActivePhoneLinesCallbacks: new Map(),
            pttDownCallbacks: new Map(),
            muteChannelCallbacks: new Map(),
            dtmfSendCallbacks: new Map(),
            callPTTOnCallbacks: new Map(),
            callPTTOffCallbacks: new Map(),
            addressBookCallbacks: new Map(),
            textMessageCallbacks: new Map(),
            endpointFilteringCallbacks: new Map(),
            endpointPropFilteringCallbacks: new Map(),
            openSessionCallbacks: new Map(),
            closeSessionCallbacks: new Map(),
            channelActivityCallbacks: new Map(),
            callMakeRequestCallbacks: new Map(),
            callHangupRequestCallbacks: new Map(),
            callAnswerRequestCallbacks: new Map(),
            clearEndpointFilterCallbacks: new Map(),
            privateMediaMessageCallbacks: new Map()
        };

        var eventDispatcher = {
            events: {},
            on: function on(event, callback) {
                var handlers = this.events[event] || [];
                handlers.push(callback);
                this.events[event] = handlers;

                return function() {
                    for (var i = 0; i < handlers.length; i++) {
                        if (callback === handlers[i]) {
                            handlers.splice(i, 1);
                            break;
                        }
                    }
                };
            },
            trigger: function trigger(event, data) {
                var handlers = this.events[event];

                if (!handlers || handlers.length < 1) return;

                [].forEach.call(handlers, function (handler) {
                    try {
                        handler(data);
                    } catch (e) {
                        util.wtcpError("An error occurred in the callback subscribed to " + event + ": " + e.message);
                    }
                });
            }
        };

        var EventSubscriber = function(event) {
            return {
                subscribe: function (callback) {
                    return eventDispatcher.on(event, callback);
                }
            }
        }

        var workerError = function workerError(e) {
            util.wtcpError(" in Worker: " + e.message);
        };

        var workerMessage = function workerMessage(e) {
            try {
                if (local[e.data.cmd].length < 2) local[e.data.cmd](e.data.value); else local[e.data.cmd](e.data.value, e.data.tranid);
            } catch (e) {
                if (typeof e.data !== "undefined") util.wtcpError("Unknown function called from worker: ", e.data.cmd); else {
                    util.wtcpError("Worker exception thrown", e);
                }
            }
        };

        var clearCallStates = function() {
            // Clear PTT pending flags since the call is no longer active
            pttUpPending = false;
            pttDownPending = false;
            pttOn = false;
        }

        Object.assign(settings, defaults, clientOptions);
        util.setLoggingLevel(settings.loggingLevel);

        var path = util.getScriptPath();

        // In future release there will be some criteria provided by locator to determine which audio handler to use
        // The correct one will be dynamically loaded at run time. For now defaulting to WTCPAudio
        var audioHandler = new audio.WTCPAudio(this, settings);

        Object.assign(local, audioHandler.messageHandlers);

        var cb;
        var instanceId = registerInstance();
        var wtcpWorker = {
            terminate: function terminate() { },
            postMessage: function postMessage() {
                throw "worker not initialized, you must first connect to a WAVE Proxy";
            }
        };

        /* --- Public properties --- */
        Object.defineProperty(this, "LibraryVersion", { get: function () {
            // this gets replaced by gulp at build-time
            return "1.0.0-2287.3715264";
        }});
        Object.defineProperty(this, "WTCPVersion", { get: function () { return locator.version; } });
        Object.defineProperty(this, "ServerId", { get: function () { return locator.proxyServerID; } });
        Object.defineProperty(this, "IsClientActive", { get: function () { return socketActive; } });
        Object.defineProperty(this, "WTCPAudioStatus", { get: function () { return audioHandler.getStatus(); } });
        Object.defineProperty(this, "AudioPlayerActive", {
            get: function () { return audioHandler.PlayerEnabled; },
            set: function (newValue) {
                settings.audioPlayerActive = newValue;
                audioHandler.PlayerEnabled = newValue;
            }
        });

        console.info('WctpJS v' + this.LibraryVersion);
        console.info('logging level: ' + settings.loggingLevel);
        // Private Function definitions

        var teardownClient = function teardownClient() {
            locator = null;
            wtcpWorker.terminate(); // Consider having worker close itself to give it a chance to shutdown gracefully
            delete proxyGlobals[instanceId];

            util.wtcpInfo("WtcpJs Client worker teardown complete");
        };

        var sendMessage = function sendMessage(cmd, tranid, value, transfer) {
            if (!socketActive && !(cmd === "init" || cmd === "connect")) throw "Can't call " + cmd + ", Socket is not active! You must call connect() before using the Client object";
            value = value || {};
            tranid = tranid || 1;

            if (!transfer) transfer = [];

            wtcpWorker.postMessage({
                "tranid": tranid,
                "cmd": cmd,
                "value": value
            }, transfer);
        };

        var init = function init() { };

        var initWorker = function initWorker() {

            sendMessage("init", 1, {
                wtcpjsPath: path + "wtcpjs.js",
                settings: settings
            });
        };

        var openSession = function openSession() {
            return new Promise(function (resolve, reject) {

                sendMessage("openSession", pushCallbacks(callbacks.openSessionCallbacks, resolve, reject), {
                    pingIntervalOption: settings.pingInterval,
                    deviceId: settings.deviceId,
                    platformString: ua ? `${settings.applicationName}-${ua.os.name}-${ua.os.version}-${ua.cpu.architecture}` : `${settings.applicationName}-?-?-?`
                });
            });
        };

        var sendCredentials = function sendCredentials(tranId, userId, password, profile) {
            //WTCP Protocol Specification says to MD5 the password, but that doesn't seem to work on proxy...
            //var md5hash = CryptoJS.MD5(password);

            if (!profile) profile = "";

            sendMessage("sendCredentials", tranId, {
                userId: userId,
                password: password,
                profile: profile,
                uuid: settings.licenseUUID
            });
        };

        var login = function login(usr, pwd, profileId) {
            util.wtcpInfo("Connect Success");

            return openSession().then(function (args) {
                return new Promise(function (resolve, reject) {
                    let tranId = pushCallbacks(callbacks.sendCredentialsCallbacks, resolve, reject);

                    if (profileId) sendCredentials(tranId, usr, pwd, profileId); else sendCredentials(tranId, usr, pwd, "");
                }, function (args) {
                    //options.error.call(this, args);
                });
            });
        };

        /* --- Worker.onmessage functions --- */

        local.setEndpointPropertiesResponse = function (data, t) {

            cb = getCallback(callbacks.setEndpointPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("setEndpointPropertiesResponse", data);
        };

        local.signalingSyntaxError = function (data) {
            eventDispatcher.trigger(eventList.SIGNAL_RECEIVED, data);
            util.wtcpInfo("Signaling op-code 1: Syntax Error received", data);
        };

        local.openSessionResponse = function (data, t) {

            cb = getCallback(callbacks.openSessionCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("OpenSessionResponse", data);
        };

        local.openSessionError = function (data, t) {
            socketActive = false;
            cb = getCallback(callbacks.openSessionCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpInfo("openSessionError", data);
        };

        local.closeSessionResponse = function (data, t) {
            teardownClient();
            cb = getCallback(callbacks.closeSessionCallbacks, t);
            if (cb) cb.resolve(); 

            util.wtcpInfo("Proxy session closed");
        };

        local.closeSessionUnsolResponse = function (data) {
            eventDispatcher.trigger(eventList.SESSION_CLOSED_RECEIVED, data);
            util.wtcpError("closeSessionError", data);
        };

        local.sendCredentialsResponse = function (data, t) {
            cb = getCallback(callbacks.sendCredentialsCallbacks, t);
            if (cb) cb.resolve(data);

            // Need to add cb here
            util.wtcpInfo("sendCredentialsResponse", data);
        };

        local.sendCredentialsError = function (data, t) {
            cb = getCallback(callbacks.sendCredentialsCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("sendCredentialsResponse", data);
            // Need to add callbacks here
        };

        local.setActiveChannelsResponse = function (data, t) {
            cb = getCallback(callbacks.setActiveChannelsCallbacks, t);
            if (cb) {
                if (data.hasErrors && data.channelResponses.length === 0) cb.reject(data.failedChannelResponses);
                else cb.resolve(data);
            }
            util.wtcpInfo("setChannelsResponse", data);
        };

        local.unsolProxyUpdate = function (data) {
            eventDispatcher.trigger(eventList.PROXY_UPDATED, data);
            util.wtcpInfo("unsolicitedProxyUpdate", data);
        };

        local.getChannelPropertiesUnsol = function (data) {
            eventDispatcher.trigger(eventList.CHANNEL_PROPS_RECEIVED, data);
            util.wtcpInfo("getChannelPropertiesUnsol", data);
        };

        local.getChannelPropertiesResponse = function (data, t) {
            cb = getCallback(callbacks.getChannelPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("getChannelPropertiesResponse", data);
        };

        local.getChannelPropertiesError = function (data, t) {
            cb = getCallback(callbacks.getChannelPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("getChannelPropertiesError", data);
        };

        local.setChannelPropertiesResponse = function (data, t) {
            cb = getCallback(callbacks.setChannelPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("setChannelPropertiesResponse", data);
        };

        local.setChannelPropertiesError = function (data, t) {
            cb = getCallback(callbacks.setChannelPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("setChannelPropertiesError", data);
        };

        local.channelActivityResponse = function (data, t) {
            cb = getCallback(callbacks.channelActivityCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("channelActivityResponse", data);
        };

        local.channelActivityError = function (err, t) {
            cb = getCallback(callbacks.channelActivityCallbacks, t);
            if (cb) {
                cb.reject(err);
            }
            util.wtcpError("channelActivityError", err);
        };

        local.channelActivityUnsolicited = function (data) {
            eventDispatcher.trigger(eventList.CHANNEL_ACTIVITY, data);
            util.wtcpInfo("channelActivityUnsolicited", data);
        };

        local.endpointLookupResponse = function (data, t) {
            cb = getCallback(callbacks.getEndpointLookupCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("endpointLookUpResponse", data);
        };

        local.endpointLookupError = function (data, t) {
            cb = getCallback(callbacks.getEndpointLookup, t);
            if (cb) {
                cb.reject(data);
            }
        };

        local.getEndpointPropertiesResponse = function (data, t) {
            cb = getCallback(callbacks.getEndpointPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
        };

        local.getEndpointPropertiesError = function (data, t) {
            cb = getCallback(callbacks.getEndpointPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
        };

        local.getEndpointPropertiesUnsolicited = function (data) {
            // Not sure if this opCode is ever sent from Proxy. Test it... if not, combine this with _RESP directly above
            eventDispatcher.trigger(eventList.ENDPOINT_PROPS_RECEIVED, data);
            util.wtcpInfo("getEndpointPropertiesUnsolicited", data);
        };

        local.setEndpointPropertiesError = function (data, t) {
            cb = getCallback(callbacks.setEndpointPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("setEndpointPropertiesError", data);
        };

        local.pttResponse = function (data, t) {
            pttDownPending = false;
            cb = getCallback(callbacks.pttDownCallbacks, t);
            if (cb) {
                if (!pttUpPending) {
                    cb.resolve(data);
                    if (audioHandler && data.channelResponses.length > 0 && data.channelResponses[0].errorCode === 0) {
                        audioHandler.sendAudio();

                        util.wtcpInfo("PTT On", data);
                    } else {
                        pttOn = false;
                        util.wtcpInfo("PTT Off", data);
                    }
                } else {
                    // PTTUp was called before the PTTDown response came back
                    pttUpPending = false;
                    util.wtcpInfo("Cancelling PTTDown because PTTUp request came before PTTDown response was received from proxy");
                    cb.reject(wtcpJsClientErrors["PTT_NOT_READY"]);
                    sendPttUp()
                        .then((data) => {
                        // TBD: This is not working correctly. PTT while another channel is clocking waiting for response
                        // leads to bad state on the channel you are trying to PTT on
                            pttUpSuccess(data);
                        })
                        .catch((err) => {
                            pttUpFailure(err);
                        });
                }
            }
        };

        local.pttError = function (err, t) {
            cb = getCallback(callbacks.pttDownCallbacks, t);
            if (cb) {
                cb.reject(err);
            }

            pttOn = false;
            pttUpPending = false;

            util.wtcpError("PTT Down Error", err);
        };

        local.pttOff = function (data, t) { // Unsolicited PTT Off message
            pttOn = false;
            eventDispatcher.trigger(eventList.PTT_OFF, data);
            util.wtcpInfo("PTT Off", data);
        };

        local.setActivePhoneLinesResponse = function (data, t) {
            cb = getCallback(callbacks.setActivePhoneLinesCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("setActivePhoneLinesResponse", data);
        };

        local.setActivePhoneLinesError = function (data, t) {
            cb = getCallback(callbacks.setActivePhoneLinesCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("ActivePhoneLineError", data);
        };

        local.phoneLineStatusUnsol = function (data, t) {
            util.wtcpInfo("phoneLineStatusUnsol", data);
            eventDispatcher.trigger(eventList.PHONE_LINE_STATUS_CHANGED, data);
        };

        local.callProgressUnsol = function(data, t) {
            util.wtcpInfo("callProgressUnsol", data);
            eventDispatcher.trigger(eventList.CALL_PROGRESS_RECEIVED, data);
        };

        local.muteChannelResponse = function (data, t) {
            cb = getCallback(callbacks.muteChannelCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Mute Channel Response", data);
        };

        local.muteChannelError = function (data, t) {
            cb = getCallback(callbacks.muteChannelCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Mute Channel Error", data);
        };

        local.pingResponse = function (data, t) {
            util.wtcpInfo("Proxy Pong", data);
        };

        local.pongResponse = function (data) {
            eventDispatcher.trigger(eventList.PING_PONG_RESPONSE, data);
            util.wtcpInfo("Proxy Pong response to client Ping", data);
        };

        local.pingRequest = function (data, t) {
            util.wtcpInfo("Proxy Ping", data);
        };

        local.dtmfResponse = function (t) {
            cb = getCallback(callbacks.dtmfSendCallbacks, t);
            if (cb) cb.resolve();

            util.wtcpInfo("DTMF Send Response");
        };

        local.dtmfError = function (data, t) {
            cb = getCallback(callbacks.dtmfSendCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("DTMF Send Error", data);
        };

        local.dtmfUnsol = function (data) {
            eventDispatcher.trigger(eventList.DTMF_RECEIEVED, data);

            util.wtcpInfo("DTMF Received", data);
        };

        local.callPttOnResponse = function (data, t) {

            pttDownPending = false;
            cb = getCallback(callbacks.pttDownCallbacks, t);
            if (cb) {
                cb.resolve(data);
                if (!pttUpPending) {
                        audioHandler.sendAudio();

                        util.wtcpInfo("Private Call PTT On", data);
                } 
            }

            cb = getCallback(callbacks.callPTTOnCallbacks, t);
            if (cb) cb.resolve(data);

            if (audioHandler && data.errorCode === 0) audioHandler.sendAudio(); else pttOn = false;

            util.wtcpInfo("Call PTT On Response", data);
        };

        local.callPttOnError = function (data, t) {
            cb = getCallback(callbacks.callPTTOnCallbacks, t);
            if (cb) cb.reject(data);

            pttOn = false;

            util.wtcpError("Call PTT On Error", data);
        };

        local.callPttOnUnsol = function (data) {
            eventDispatcher.trigger(eventList.CALL_PTT_ON_RECEIVED, data);
            util.wtcpInfo("Call PTT On Received", data);
        };

        local.callPttOffResponse = function (data, t) {
            cb = getCallback(callbacks.callPTTOffCallbacks, t);
            if (cb) cb.resolve(data);

            pttOn = false;

            if (pttUpPending) {
                pttUpPending = false;
                util.wtcpInfo("Cancelling callPTTOn because callPTTOff request came before callPTTOn response was received from proxy");
                sendCallPttUp(d.callId)
                    .then((data) => {
                        pttUpSuccess(data);
                    })
                    .catch((err) => {
                        pttUpFailure(err);
                    });
            }

            util.wtcpInfo("Call PTT Off Response", data);
        };

        local.callPttOffError = function (data, t) {
            cb = getCallback(callbacks.callPTTOffCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Call PTT Off Error", data);
        };

        local.callPttOffUnsol = function (data) {
            eventDispatcher.trigger(eventList.CALL_PTT_OFF_RECEIVED, data);
            util.wtcpInfo("Call PTT Off Received", data);
        };

        local.addressBookGetResponse = function (data, t) {
            cb = getCallback(callbacks.addressBookCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }

            util.wtcpInfo("Address Book Info Response", data);
        };

        local.textMessageResponse = function (data, t) {
            cb = getCallback(callbacks.textMessageCallbacks, t);
            if (cb) {
                data.textMsgConfirmedDate = new Date(Date.now());
                cb.resolve(data);
            }

            util.wtcpInfo("Text Message Sent", data);
        };

        local.textMessageError = function (data, t) {
            cb = getCallback(callbacks.textMessageCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Error sending Text Message", data);
        };

        local.textMessageUnsol = function (data) {
            eventDispatcher.trigger(eventList.TXT_MSG_RECEIVED, data);
            util.wtcpInfo("Text Message Received", data);
        };

        local.privateMediaMessageResponse = function (data, t) {
            cb = getCallback(callbacks.privateMediaMessageCallbacks, t);
            if(cb) {
                data.textMsgConfirmedDate = new Date(Date.now());
                cb.resolve(data);
            }

            util.wtcpInfo("Private Media Message Sent", data);
        };

        local.privateMediaMessageError = function (data, t) {
            cb = getCallback(callbacks.privateMediaMessageCallbacks, t) ;
            if(cb) cb.reject(data);

            util.wtcpError("Error sending Private Media Message");
        }

        local.privateMediaMessageUnsol = function(data, t) {
            eventDispatcher.trigger(eventList.PRIV_MEDIA_MSG_RECEIVED, data);
            util.wtcpInfo("Private Media Message Received", data);
        };

        local.callMakeResponse = function(data, t) {
            cb = getCallback(callbacks.callMakeRequestCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }
            util.wtcpInfo("Call Make acknowledged by Proxy", data);
        };

        local.callHangupResponse = function(data, t) {
            clearCallStates();
            cb = getCallback(callbacks.callHangupRequestCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }
            util.wtcpInfo("Call Hang-up acknowledged by Proxy", data);
        };

        local.callAnswerResponse = function(data, t) {
            cb = getCallback(callbacks.callAnswerRequestCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }
            util.wtcpInfo("Call Answer acknowledged by Proxy", data);
        };

        local.callHangupUnsol = function(data, t) {
            clearCallStates();
            eventDispatcher.trigger(eventList.CALL_HANGUP_RECEIVED, data);
            util.wtcpInfo("Call Hangup Received", data);
        };

        local.callOfferUnsol = function(data, t) {
            eventDispatcher.trigger(eventList.CALL_OFFER_RECEIVED, data);
            util.wtcpInfo("Call Offer Received", data);
        };

        // Version 2
        local.setEndpointPropertiesFilterResponse = function (data, t) {
            cb = getCallback(callbacks.endpointPropFilteringCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Set Endpoint Prop Filter Response", data);
        };

        local.setEndpointPropertiesFilterError = function (data, t) {
            cb = getCallback(callbacks.endpointPropFilteringCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Set Endpoint Prop Filter Error", data);
        };

        local.setEndpointFilterResponse = function (data, t) {
            cb = getCallback(callbacks.endpointFilteringCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Set Endpoint Filter Response", data);
        };

        local.setEndpointFilterError = function (data, t) {
            cb = getCallback(callbacks.endpointFilteringCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Set Endpoint Filter Error", data);
        };

        local.clearEndpointFilterResponse = function(data, t) {
            cb = getCallback(callbacks.clearEndpointFilterCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Clear Endpoint Filer Response", data);
        };

        local.clearEndpointFilterError = function(data, t) {
            cb = getCallback(callbacks.clearEndpointFilterCallbacks, t);

            if (cb) cb.reject(data);

            util.wtcpError("Clear Endpoint Filter Error", data);
        };

        local.playAudio = function (data) {
            //audioHandler.playAudio(d.audioMessages, d.audioLength, d.data);
            audioHandler.playAudio(data.audioArrayBuffer, data.audioLength);
        };

        local.connectionInfoUpdated = function(data, t) {
            eventDispatcher.trigger(eventList.CONNECTION_INFO_UPDATED, data);
            util.wtcpInfo("Connection Info Updated", data);
        };

        local.wsConnected = function (d, t) {
            socketActive = true;

            cb = getCallback(callbacks.socketConnectedCallbacks, t);
            if (cb) cb.resolve();

            util.wtcpInfo("Web Socket connection established");
        };

        local.wsClosed = function (closeEvent) {
            socketActive = false;
            eventDispatcher.trigger(eventList.SOCKET_CLOSED, closeEvent);
            util.wtcpInfo("Web Socket connection closed", closeEvent);
        };

        local.wsError = function (data, t) {
            cb = getCallback(callbacks.socketConnectedCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Web Socket connection failed", data);
        };

        // Expose two functions for unit testing

        this.pushCallbacks = pushCallbacks;
        this.getCallback = getCallback;

        /* --- Public events --- */
        this.onConnectionClosed = new EventSubscriber(eventList.SOCKET_CLOSED);

        this.onSessionClosed = new EventSubscriber(eventList.SESSION_CLOSED_RECEIVED);

        this.onProxyUpdated = new EventSubscriber(eventList.PROXY_UPDATED);

        this.onChannelPropertiesReceived = new EventSubscriber(eventList.CHANNEL_PROPS_RECEIVED);

        this.onChannelActivity = new EventSubscriber(eventList.CHANNEL_ACTIVITY);

        this.onEndpointPropertiesReceived = new EventSubscriber(eventList.ENDPOINT_PROPS_RECEIVED);

        this.onPhoneLineStatusChanged = new EventSubscriber(eventList.PHONE_LINE_STATUS_CHANGED);

        this.onCallProgressReceived = new EventSubscriber(eventList.CALL_PROGRESS_RECEIVED);

        this.onCallHangupReceived = new EventSubscriber(eventList.CALL_HANGUP_RECEIVED);

        this.onCallOfferReceived = new EventSubscriber(eventList.CALL_OFFER_RECEIVED);

        this.onPTTOff = new EventSubscriber(eventList.PTT_OFF);

        this.onDTMFReceived = new EventSubscriber(eventList.DTMF_RECEIEVED);

        this.onCallPTTOnReceived = new EventSubscriber(eventList.CALL_PTT_ON_RECEIVED);

        this.onCallPTTOffReceived = new EventSubscriber(eventList.CALL_PTT_OFF_RECEIVED);

        this.onTextMessageReceived = new EventSubscriber(eventList.TXT_MSG_RECEIVED);

        this.onPrivateMediaMessageReceived = new EventSubscriber(eventList.PRIV_MEDIA_MSG_RECEIVED);

        this.onPingResponse = new EventSubscriber(eventList.PING_PONG_RESPONSE);

        this.onConnectionInfoUpdated = new EventSubscriber(eventList.CONNECTION_INFO_UPDATED);

        /* --- Public client functions --- */
        this.connect = function (serverUrl, username, password, profileId) {

            if (wtcpWorker) {
                // Re-connecting - terminate existing worker
                wtcpWorker.onerror = null;
                wtcpWorker.onmessage = null;
                wtcpWorker.terminate();
                locator = null;
            }

            wtcpWorker = clientWorker || new Worker(path + 'wtcp-worker-api.js');

            wtcpWorker.onerror = workerError;
            wtcpWorker.onmessage = workerMessage;

            initWorker();

            return new Promise(function (resolve, reject) {
                var tranId = pushCallbacks(callbacks.socketConnectedCallbacks, resolve, reject);
                locator = new locService.Locator();
                if (serverUrl.match(serverUrlPattern)) {
                    locator.webSocketServer = serverUrl;

                    sendMessage("connect", tranId, {
                        locator: locator
                    });
                } else {
                    locator.getProxy(serverUrl).then(function () {
                        if (locator.proxyServerID == null) throw "Locator not initialized, call getProxy()";

                        let _address;
                        if (locator.wsPort) {
                            _address = `${locator.address[0]}:${locator.wsPort}`;
                        } else {
                            _address = locator.address[0];
                        }

                        if (!!serverUrl.match(httpsPattern)) {
                            locator.webSocketServer = `wss://${_address}`;
                        } else {
                            locator.webSocketServer = `ws://${_address}`;
                        }

                        sendMessage("connect", tranId, {
                            locator: locator
                        });
                    })["catch"](function (err) {
                        reject(err);
                    });
                }
            }).then(function () {
                return login(username, password, profileId);
            }, function (err) {
                throw "error connecting to Proxy";
            });
        };

        this.setProfile = function (username, password, profileId) {
            return new Promise(function (resolve, reject) {
                let tranId = pushCallbacks(callbacks.sendCredentialsCallbacks, resolve, reject);

                sendCredentials(tranId, username || "", password || "", profileId || "");
            });
        };

        // Proxy Request Messages
        this.closeSession = function () {
            return new Promise(function(resolve, reject) {
                sendMessage("closeSession", pushCallbacks(callbacks.closeSessionCallbacks, resolve, reject));
            });
        };

        this.setActiveChannels = function (channelIds) {
            if (!channelIds || !(typeof channelIds === "object")) channelIds = [];

            return new Promise(function (resolve, reject) {

                sendMessage("setActiveChannels", pushCallbacks(callbacks.setActiveChannelsCallbacks, resolve, reject), {
                    channelIds: channelIds
                });
            });
        };

        this.getChannelProperties = function (channelId) {
            ///<summary>Requests Channel Properties from Proxy</summary>
            ///<param name="channelId" type="int">Channel ID to request properties for</param>
            if (!channelId) throw "getChannelPropertiesRequest(channelId) requires a valid channel Id";

            return new Promise(function (resolve, reject) {

                sendMessage("getChannelPropertiesRequest", pushCallbacks(callbacks.getChannelPropsCallbacks, resolve, reject), {
                    channelId: channelId
                });
            });
        };

        this.setChannelProperties = function (channelId, props) {
            ///<summary>Request Proxy save or update Channel Properties</summary>
            ///<param name="channelId" type="int">Channel ID to set properties for</param>
            ///<param name="props" type="object">json object containing key-value pairs</param>
            if (!channelId) throw "setChannelPropertiesRequest(channelId, properties) expects a valid channel Id";

            return new Promise(function (resolve, reject) {

                sendMessage("setChannelPropertiesRequest", pushCallbacks(callbacks.setChannelPropsCallbacks, resolve, reject), {
                    channelId: channelId,
                    props: props
                });
            });
        };

        this.getChannelActivity = function (channelId) {
            if (!channelId) throw "channelActivityRequest(channelId) requires a valid channel Id";

            return new Promise(function (resolve, reject) {

                sendMessage("channelActivityRequest", pushCallbacks(callbacks.channelActivityCallbacks, resolve, reject), {
                    channelId: channelId
                });
            });
        };

        this.endpointLookup = function (channelId, includeFlags, excludeFlags, pageSize, pageNumber, nameBeginsWith) {
            if (!channelId) throw "channelActivityRequest(channelId) requires a valid channel Id";

            includeFlags = includeFlags || new wtcp.EndpointFlags();
            excludeFlags = excludeFlags || new wtcp.EndpointFlags();
            pageSize = pageSize || 1;
            pageNumber = pageNumber || 1;
            nameBeginsWith = nameBeginsWith || "";

            return new Promise(function (resolve, reject) {

                sendMessage("endpointLookupRequest", pushCallbacks(callbacks.getEndpointLookupCallbacks, resolve, reject), {
                    channelId: channelId,
                    includeFlags: includeFlags,
                    excludeFlags: excludeFlags,
                    pageSize: pageSize,
                    pageNumber: pageNumber,
                    nameBeginsWith: nameBeginsWith
                });
            });
        };

        this.getEndpointProperties = function (endpointId, propList, channelId) {
            if (!endpointId) throw "getEndpointProperties(endpointId, properties) requires a valid endpoint Id";

            var msgBody = {
                endpointId: endpointId,
                propList: propList
            };

            if (channelId != null) {
                msgBody.channelId = channelId;
            }

            return new Promise(function (resolve, reject) {

                sendMessage("getEndpointPropertiesRequest", pushCallbacks(callbacks.getEndpointPropsCallbacks, resolve, reject), msgBody );
            });
        };

        this.setEndpointProperties = function (endpointId, props) {
            if (!endpointId) throw "setEndpointProperties(endpointId, properties) requires a valid endpoint Id";

            return new Promise(function (resolve, reject) {

                sendMessage("setEndpointPropertiesRequest", pushCallbacks(callbacks.setEndpointPropsCallbacks, resolve, reject), {
                    endpointId: endpointId,
                    props: props
                });
            });
        };

        this.PTTDown = function (channelIds) {
            if (!channelIds || Object.prototype.toString.call(channelIds) !== "[object Array]" || channelIds.length === 0) throw "PTTDown requires an array of channel ids";
            pttDownPending = true;

            return new Promise(function (resolve, reject) {

                if (!pttOn && !pttUpPending) {
                    pttOn = true;
                    sendMessage("PTTDown", pushCallbacks(callbacks.pttDownCallbacks, resolve, reject), {
                        channelIds: channelIds
                    });
                } else {
                    util.wtcpError(`ALERT: PTTDown pttOn=${pttOn} and pttUpPending=${pttUpPending}`);
                    reject(wtcpJsClientErrors["PTT_NOT_READY"]);
                }
            });
        };

        function sendPttUp() {
            let sendMessagePromise = new Promise(function (resolve, reject) {
                sendMessage("PTTUp", pushCallbacks(callbacks.pttDownCallbacks, resolve, reject));
            });

            // wait promise for a second before timeout 
            return util.promiseTimeout(1000, sendMessagePromise)
                    .then((result) => { util.wtcpInfo("Sending a message : ", result); 
                                        return result; })
                    .catch(err => { util.wtcpInfo("ALERT : sending a message :",err);
                                    return err; });
        }

        function awaitPttUp() {
            let awaitPromise =  new Promise(function(resolve, reject) {
                pttUpPending = true;
                pttUpSuccess = resolve;
                pttUpFailure = reject;
            });

            // wait promise for a second before timeout
            return util.promiseTimeout(1000, awaitPromise)
                   .then((result) => { util.wtcpInfo("awaitPttUp done, result =", result);
                                       pttUpPending = false; 
                                       pttOn = false;
                                       return result;
                                     })
                   .catch(err => { util.wtcpInfo("awaitPttUp. exception =", errr);
                                   return err;
                                  });
        }

        this.PTTUp = function () {
            if (pttDownPending) {
                return awaitPttUp();
            } else {
                if (audioHandler) {
                    return util.promiseTimeout(1000, audioHandler.endAudio())
                            .then(() => {return sendPttUp();})
                            .catch((err) => {
                                // will send sendPttUp even if failed to close endAudio
                                util.wtcInfo('ALERT: PttUp failed while waiting endAudio call', err);
                                return sendPttUp();
                            });
                } else {
                    util.wtcpDebug("no audio handler");
                    return sendPttUp();
                }
            }
        };

        function sendCallPttUp(callId) {
            return new Promise(function (resolve, reject) {
                sendMessage("callPTTOffRequest", pushCallbacks(callbacks.callPTTOffCallbacks, resolve, reject), {
                    callId: callId
                });
            });
        }

        this.callPTTOn = function(callId) {
            if (!callId) throw "callPTTOn(callId) requires a valid call Id";

            pttDownPending = true;

            return new Promise(function(resolve, reject) {

                if (!pttOn) {
                    pttOn = true;

                    sendMessage("callPTTOnRequest", pushCallbacks(callbacks.callPTTOnCallbacks, resolve, reject), {
                        callId: callId
                    });
                } else {
                    reject(wtcpJsClientErrors["PTT_NOT_READY"]);
                }
            });
        };

        this.callPTTOff = function (callId) {
            if (!callId) throw "callPTTOff(callId) requires a valid call Id";

            if (pttDownPending) {

                return awaitPttUp();
            } else {
                if (audioHandler) {
                    return audioHandler.endAudio().then(() => {
                        return sendCallPttUp(callId);
                    }).catch((err) => {
                        util.wtcpError('callPTTOff failed', err);
                    });
                } else {
                    return sendCallPttUp(callId);
                }
            }
        };

        this.setActivePhoneLines = function (phoneLines) {
            let fail = !phoneLines;

            if (!fail) {
                for (let line of phoneLines) {
                    if (!line) {
                        fail = true;
                        break;
                    }
                }
            }

            if (fail ) throw "setActivePhoneLines requires a list of phone lines";

            return new Promise(function (resolve, reject) {

                sendMessage("setActivePhoneLines", pushCallbacks(callbacks.setActivePhoneLinesCallbacks, resolve, reject), {
                    phoneLines: phoneLines
                });
            });
        };

        this.makeCall = function (type, source, destination) {
            ///<summary>Make a point-to-point call request</summary>
            ///<param name="type" type="int">Endpoint == 1, E164 number == 2</param>
            ///<param name="source" type="string">Phone line to use to make the call (as returned by "Start Call Provider") response</param>
            ///<param name="destination" type="string">if type === 1, then this is the endpoint to reach, otherwise it is the phone number to call</param>
            ///<returns type="Promise">Returns a Promise</returns>
            if (!type) throw "makeCall(type, source, destination) requires type, source, and destination";

            return new Promise(function (resolve, reject) {

                sendMessage("callMakeRequest", pushCallbacks(callbacks.callMakeRequestCallbacks, resolve, reject), {
                    type: type,
                    source: source,
                    destination: destination
                });
            });
        };

        this.answerCall = function(callId) {
            if (!callId) throw "answerCall requires a valid call Id";

            return new Promise(function(resolve, reject) {
                sendMessage("callAnswerRequest", pushCallbacks(callbacks.callAnswerRequestCallbacks, resolve, reject), {
                    callId: callId
                });
            });
        };

        this.hangupCall = function (callId) {
            if (!callId) throw "hangupCall requires a valid call Id";

            return new Promise(function (resolve, reject) {

                sendMessage("callHangUpRequest", pushCallbacks(callbacks.callHangupRequestCallbacks, resolve, reject), {
                    callId: callId
                });
            });
        };

        this.muteAllChannels = function () {
            return new Promise(function (resolve, reject) {

                sendMessage("muteAllChannels", pushCallbacks(callbacks.muteChannelCallbacks, resolve, reject));
            });
        };

        this.unmuteAllChannels = function () {
            return new Promise(function (resolve, reject) {

                sendMessage("unmuteAllChannels", pushCallbacks(callbacks.muteChannelCallbacks, resolve, reject));
            });
        };

        this.muteChannels = function (channels) {
            if (!channels) throw "muteChannels(chanels) requires a valid list of channels";

            return new Promise(function (resolve, reject) {

                sendMessage("muteChannels", pushCallbacks(callbacks.muteChannelCallbacks, resolve, reject), { channels: channels });
            });
        };

        this.dtmfSendRequest = function (callId, dtmf) {
            if (!callId) throw "dtmfSendRequest(callId) was called without a valid callId";

            return new Promise(function (resolve, reject) {

                sendMessage("dtmfSendRequest", pushCallbacks(callbacks.dtmfSendCallbacks, resolve, reject), {
                    callId: callId,
                    dtmf: dtmf
                });
            });
        };

        this.getAddressBook = function (pageSize, pageNum, filter) {
            if (locator.version === 1 || !filter || filter.length === 0) filter = "*";

            return new Promise(function (resolve, reject) {

                sendMessage("getAddressBook", pushCallbacks(callbacks.addressBookCallbacks, resolve, reject), {
                    pageSize: pageSize || 200,
                    pageNum: pageNum || 1,
                    filter: filter
                });
            });
        };

        function getDefaultOptions() {
            var options = {};

            if (!options.hasOwnProperty("important")) options.important = false;

            return options
        }

        this.sendTextMessage = function (channelId, message, options) {
            if (!channelId || typeof channelId !== "number") throw "sendTextMessage(channelId, message) requires a valid channel Id";

            options = options || getDefaultOptions();

            if (options.important) message = "[[ALERT1]]" + message;

            return new Promise(function (resolve, reject) {

                // Only channel text messages are currently implemented
                sendMessage("sendTextMessage", pushCallbacks(callbacks.textMessageCallbacks, resolve, reject), {
                    channelId: channelId,
                    message: message
                });
            });
        };

        this.sendP2PMessage = function(privateTextMessageRequest, options) {
            if (!privateTextMessageRequest || !privateTextMessageRequest instanceof wtcp.PrivateTextMessageRequest) throw "sendP2PMessage(privateTextMessageRequest) argument must be type PrivateTextMessageRequest";

            options = options || getDefaultOptions();

            // eventually this should be replaced with metadata and handled in the client, not WtcpJs
            if (options.important) privateTextMessageRequest.data = "[[ALERT1]]" + privateTextMessageRequest.data;

            return new Promise(function (resolve, reject) {

                // assumed will always be a text/plain message. We will have to change the signature when we support multimedia messages
                sendMessage("sendP2PMessage", pushCallbacks(callbacks.privateMediaMessageCallbacks, resolve, reject), privateTextMessageRequest);
            });
        }

        // Version 2
        var setEndpointFilter = function setEndpointFilter(type, filterId, channelId, endpointFilter, propFilter, endpointId, threshold, anchor) {
            /*if (locator.version < 2)
                throw "Endpoint filtering is only supported in WTCP version 2 or greater";*/

            return new Promise(function (resolve, reject) {

                sendMessage("setEndpointFilter", pushCallbacks(callbacks.endpointFilteringCallbacks, resolve, reject), {
                    filterId: filterId,
                    type: type,
                    channelId: channelId,
                    endpointFilter: endpointFilter,
                    propertyFilter: propFilter,
                    endpointId: endpointId,
                    notificationThreshold: threshold,
                    anchorInfo: anchor
                });
            });
        };

        this.setEndpointChannelFilter = function (filterId, channelId, endpointFilter, propFilter, threshold, anchorInfo) {
            if (!channelId) throw "channelId argument is required";

            return setEndpointFilter(2, filterId, channelId, endpointFilter, propFilter, '', threshold, anchorInfo);
        };

        this.setEndpointSPCFilter = function (filterId, endpointId, endpointFilter, propFilter, threshold, anchorInfo) {
            return setEndpointFilter(1, filterId, 0, endpointFilter, propFilter, endpointId, threshold, anchorInfo);
        };

        this.setEndpointAddressBookFilter = function (filterId, endpointFilter, propFilter, threshold, anchorInfo) {
            return setEndpointFilter(3, filterId, 0, endpointFilter, propFilter, '', threshold, anchorInfo);
        };

        this.clearEndpointFilter = function (filterId) {
            if (!filterId || isNaN(filterId)) throw new Error("Invalid argument type for filterId, must be an unsigned integer value");

            return new Promise(function (resolve, reject) {

                // Only channel text messages are currently implemented
                sendMessage("clearEndpointFilter", pushCallbacks(callbacks.clearEndpointFilterCallbacks, resolve, reject), {
                    filterId: filterId
                });
            });
        };

        var setEndpointPropertiesFilter = function(type, filter) {
            if (type < 1 || type > 6) throw "setEndpointPropertiesFilter(type, filter) type argument is required";

            return new Promise(function (resolve, reject) {

                sendMessage("setEndpointPropertiesFilter", pushCallbacks(callbacks.endpointPropFilteringCallbacks, resolve, reject), { type: type, filter: filter });
            });
        };

        this.setEndpointPropertiesPrivateCallFilter = function (filter) {
            return setEndpointPropertiesFilter(1, filter);
        };

        this.setEndpointPropertiesTextMessageFilter = function (filter) {
            return setEndpointPropertiesFilter(2, filter);
        };

        this.setEndpointPropertiesChannelActivityFilter = function (filter) {
            return setEndpointPropertiesFilter(3, filter);
        };

        this.setEndpointPropertiesPrivateMessageFilter = function (filter) {
            return setEndpointPropertiesFilter(4, filter);
        };

        this.visualizeAudio = function (canvas) {
            audioHandler.visualize(canvas);
        };

        this.setVolume = function (volume) {
            audioHandler.setVolume(volume);
        };

        this.destroy = function () {
            if (socketActive)
                return this.closeSession();
            else return new Promise(function(resolve, reject) {
                try {
                    teardownClient();
                } catch (e) {
                    reject(e);
                } finally {
                    eventDispatcher.events = {};
                    resolve();
                }
            });
        };

        this.SendMessage = sendMessage;

        init();

        return this;
    };

    module.exports = wtcp;
})(global.WtcpJs);
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./wtcp-types/ErrorResponse.js":2,"./wtcp-types/requests/AnchorInfo.js":3,"./wtcp-types/requests/PrivateTextMessageRequest.js":4,"./wtcp.locator.js":6,"./wtcp.util.js":7,"./wtcp.wtcpaudio.js":8,"ua-parser-js":10}],6:[function(require,module,exports){
(function (global){(function (){
/// <reference path="wtcp.util.js"/>
global.WtcpJs = global.WtcpJs || {};

var util = require('./wtcp.util.js');

(function(locatorModule) {

    function getNonce() {
        return Math.floor(Math.random() * 9999) + 1;
    }

    locatorModule.JXON = function(options) {
        if (!(this instanceof locatorModule.JXON))
            return new locatorModule.JXON(options);

        return this;
    };

    /*locatorModule.JXON.prototype = Object.create(locatorModule.WtcpBase.prototype);
    locatorModule.JXON.prototype.constructor = locatorModule.JXON;*/

    locatorModule.JXON.prototype.getJXONTree = function(oXMLParent) {
        oXMLParent.hasAttributes = oXMLParent.hasAttributes || function() { return false; };
        var vResult = /* put here the default value for empty nodes! */ true, nLength = 0, sCollectedTxt = "", oAttrib = null;
        if (oXMLParent.hasAttributes()) {
            vResult = {};
            for (nLength; nLength < oXMLParent.attributes.length; nLength++) {
                oAttrib = oXMLParent.attributes.item(nLength);
                vResult["@" + oAttrib.name.toLowerCase()] = this.parseText(oAttrib.value.trim());
            }
        }
        if (oXMLParent.hasChildNodes()) {
            for (var oNode, sProp, vContent, nItem = 0; nItem < oXMLParent.childNodes.length; nItem++) {
                oNode = oXMLParent.childNodes.item(nItem);
                if (oNode.nodeType === 4) {
                    sCollectedTxt += oNode.nodeValue;
                } /* nodeType is "CDATASection" (4) */
                else if (oNode.nodeType === 3) {
                    sCollectedTxt += oNode.nodeValue.trim();
                } /* nodeType is "Text" (3) */
                else if (oNode.nodeType === 1 && !oNode.prefix) { /* nodeType is "Element" (1) */
                    if (nLength === 0) {
                        vResult = {};
                    }
                    sProp = oNode.nodeName.toLowerCase();
                    vContent = this.getJXONTree(oNode);
                    if (vResult.hasOwnProperty(sProp)) {
                        if (vResult[sProp].constructor !== Array) {
                            vResult[sProp] = [vResult[sProp]];
                        }
                        vResult[sProp].push(vContent);
                    } else {
                        vResult[sProp] = vContent;
                        nLength++;
                    }
                }
            }
        }
        if (sCollectedTxt) {
            nLength > 0 ? vResult.keyValue = this.parseText(sCollectedTxt) : vResult = this.parseText(sCollectedTxt);
        }
        /* if (nLength > 0) { Object.freeze(vResult); } */
        return vResult;
    }

    locatorModule.JXON.prototype.parseText = function(sValue) {
        if (/^\s*$/.test(sValue)) {
            return null;
        }
        if (/^(?:true|false)$/i.test(sValue)) {
            return sValue.toLowerCase() === "true";
        }
        if (isFinite(sValue)) {
            return parseFloat(sValue);
        }
        if (isFinite(Date.parse(sValue))) {
            return new Date(sValue);
        }
        return sValue;
    };

    locatorModule.Locator = function(options) {
        if (!(this instanceof locatorModule.Locator))
            return new locatorModule.Locator(options);

        locatorModule.JXON.call(this);
        this.proxyServerID = null;
        this.proxyIndex = null;
        this.address = [];
        this.port = [];
        this.wsPort = 443;
        this.softwareVersionCheckUrl = null;
        this.version = 2;
        this.controlVersion = 1;
        this.httpStatusCode = 200; 

        return this;
    };

    locatorModule.Locator.prototype = Object.create(locatorModule.JXON.prototype);
    locatorModule.Locator.prototype.constructor = locatorModule.Locator;

    locatorModule.Locator.prototype.getProxy = function (proxyurl) {
        let _proxyurl = proxyurl;
        return this.tryToGetProxy(
            `${_proxyurl}/waveapi/proxy_locator.asp?action=getproxy&pc=wtcpJs&ver=3.0.0&requires=WTCPv2&nonce=${getNonce()}`)
            .then( result => { 
                    // Due to hardening, we got 403 forbidden response
                    // we try again with new URL /wave/_locator/proxy_locator.asp with the same parameter 
                        if( result.httpStatusCode == 403) {
                            return  this.tryToGetProxy(
                                `${_proxyurl}/wave/_locator/proxy_locator.asp?action=getproxy&pc=wtcpJs&ver=3.0.0&requires=WTCPv2&nonce=${getNonce()}`)
                                .then(result => {return result; });
                        }
                        else {
                                 return result; 
                        }
                 },
                error => { 
                        util.wtcpError("Error to get proxy", error);
                        return Promise.reject(error);
                })
                .then(result => { return result;},
                        err =>  { util.wtcpError("Exception at getProxy: ", err); return Promise.reject(err);} );

     }

    locatorModule.Locator.prototype.tryToGetProxy = function (targetUrl) {
        let locatorUrl = targetUrl;
        var _this = this;
        return new Promise(function(resolve, reject) {
                var oReq = new XMLHttpRequest();

                util.wtcpInfo("TPS Locator | getProxy url: " , locatorUrl);

                oReq.onload = function(e) {

                _this.httpStatusCode = e.currentTarget.status;
                if (e.currentTarget.status === 200) {
                    var response = _this.getJXONTree(this.responseXML);
                    if (response.serverresponse["@error"])
                        util.wtcpError("Proxy Locator returned error code " + response.serverresponse["@error"]);
                    else {
                        var proxy = response.serverresponse.proxy;
                        _this.proxyServerID = proxy["@serverid"];
                        _this.proxyIndex = proxy["@proxyindex"];
                        _this.address[0] = proxy["@address1"];
                        _this.address[1] = proxy["@address2"];
                        _this.port[0] = proxy["@port1"];
                        _this.port[1] = proxy["@port2"];
                        _this.wsPort = proxy["@wsport"];
                        _this.softwareVersionCheckUrl = proxy["@softwareversioncheckurl"];
                        _this.version = 2; // TBD: WTCP version number should be added to locator service
                        _this.controlVersion = 1; // TBD: WTCP-Ctrl OpCode version should be added to locator service
                    
                        util.wtcpInfo("TPS Locator | proxyIndex: " + _this.proxyIndex + ", ProxyServerID: " +
                            _this.proxyServerID + ", addrss1: " +
                            _this.address[0] + ", address2: " +
                            _this.address[1] + ", port1: " +
                            _this.port[0] + ", port2: " +
                            _this.port[1]);
                    }
                } 
                resolve(_this);
            };

            oReq.onerror = function(err) {
                if (typeof reject !== "undefined" && reject)
                    reject(err.statusText);
            }

            oReq.open("get", locatorUrl, true);
            try
            {
                oReq.send();   
            }
            catch(ex)
            {
                reject("exception in tryToGetProxy : "+ ex);
            }
            
        }); 
    }

    module.exports = locatorModule;

})(global.WtcpJs);
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./wtcp.util.js":7}],7:[function(require,module,exports){
(function (global){(function (){
"use strict";

global.WtcpJs = global.WtcpJs || {};

(function() {
    let doc;
    let decoder;
    let loggingLevels = {
        none: 0,
        error: 1,
        warn: 2,
        debug: 3,
        info: 4
    };

    let baseLogMsg = 'WtcpJs:';

    try {
        doc = document;
    } catch (e) {
        doc = undefined;
    }

    var scriptPath = '';
    if (doc) {
        var scriptEls = doc.getElementsByTagName('script');
        var thisScriptEl = scriptEls[scriptEls.length - 1];
        var scriptSrc = thisScriptEl.src;
        scriptPath = scriptSrc.substr(0, scriptSrc.lastIndexOf('/') + 1);
    }

    // Detect Endianness
    var littleEndian = (function() {
        var buffer = new ArrayBuffer(2);
        new DataView(buffer).setInt16(0, 256, true);
        return new Int16Array(buffer)[0] === 256;
    })();

    //let wtcpLog = Symbol('wtcpLog');

    var WtcpUtil = function() {

        this.logLevel = 0;

        // Public properties
        Object.defineProperty(this, "Path", { get: function() { return scriptPath; } });
        Object.defineProperty(this, "LittleEndian", { get: function() { return littleEndian; } });
    };

    // default to 'info' - 3. If we don't specify or bad value, get as much info as possible
    WtcpUtil.prototype.setLoggingLevel = function (value) {
        if (!Number.isInteger(value))
            value = value in loggingLevels ? loggingLevels[value] : 4; // default to 'info'

        this.logLevel = value < 0 ? 0 : value > 4 ? 4 : value; // 0 <= logLevel <= 3
    }

    function formatLogMsg(fn, msg, args) {
        fn.call(console, `${baseLogMsg} ${msg}`, args);
    }

    WtcpUtil.prototype.wtcpInfo = function(e, ...args) {
        if (this.logLevel >= loggingLevels.info)
            formatLogMsg(console.info, e, args);
    }

    WtcpUtil.prototype.wtcpDebug = function(e, ...args) {
        if(this.logLevel >= loggingLevels.debug)
            formatLogMsg(console.debug, e, args);
    }

    WtcpUtil.prototype.wtcpWarn = function(e, ...args) {
        if (this.logLevel >= loggingLevels.warn)
            formatLogMsg(console.warn, e, args);
    }

    WtcpUtil.prototype.wtcpError = function(e, ...args) {
        if(this.logLevel >= loggingLevels.error)
            formatLogMsg(console.error, e, args);
    }

    var messages = '';

    WtcpUtil.prototype.debugWindow = function(messageClass, message) {
        var date = new Date();
        var time = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds();
        messages += time + " | " + messageClass + ":  " + message + "\n";

        //doc.getElementById("debugMessageWindow").innerText = messages;
    };

    WtcpUtil.prototype.loadScript = function(filename, callback) {
        if (doc !== undefined) {
            var scriptElem = doc.createElement('script');
            scriptElem.setAttribute("type", "text/javascript");
            scriptElem.setAttribute("src", filename);
            scriptElem.onload = function(e) {
                if (callback)
                    callback.call(this, e);
            };
            scriptElem.onerror = function(e) {
                if (callback)
                    callback.call(this, e);
            }
            doc.getElementsByTagName("head")[0].appendChild(scriptElem);
        } else {
            throw "Use importScripts from Web Workers, loadScript only works from UI thread";
        }
    };

    WtcpUtil.prototype.getScriptPath = function() {
        return scriptPath;
    };

    WtcpUtil.prototype.byteWriter = function(view, val, length, offset) {
        //only use this for tiny, short, or int (length 1, 2, or 4)
        //doesn't work for setting negative values
        //needs a lot of work, need to switch to using dataview??
        var shift;
        if (!offset)
            offset = 0;

        var n = offset + length;

        for (var x = offset; x < n; x++) {
            shift = ((n - (x + 1)) * 8);
            if (x === offset)
                view[x] = val >>> shift;
            else
                view[x] = (val >>> shift) ^ (view[x - 1] << 8);
        }
    };

    WtcpUtil.prototype.stringReader = function(data, position) {
        ///<summary>Gets the UTF-8 string value from byte stream at specified position</summary>
        ///<param name="view" type="ArrayBuffer"></param>
        ///<param name="position" type="Number">Numeric position from beginning of ArrayBuffer to start reading</param>
        ///<returns type="Number or Object">returns {string: 'text', str_terminate: position}</returns>
        try {
            decoder = new TextDecoder("utf-8");
        } catch (e) {
            //TBD: Works in Chrome, but need to add poly-fill or use existing library if not defined
            throw "browser does not support TextDecoder";
        }

        var i;
        var str = "";

        try {

            var view = new Uint8Array(data);

            for (i = position; i < view.length; i++) {
                if (view[i] === 0)
                    break;
            }

            var strView = new Uint8Array(data, position, i - position);

            str = decoder.decode(strView);

        } catch (exc) {
            this.wtcpError("Error decoding UTF-8 string", exc);
        }

        return { value: str, position: i };
    };

    WtcpUtil.prototype.byteReader = function(view, length, offset) {
        ///<summary>Retrieve value from byte stream at specified offset and length</summary>
        ///<param name="view" type="ArrayBufferView"></param>
        ///<param name="length" type="Number">Number of bytes to read</param>
        ///<param name="offset" type="Number">Numeric offset from beginning of ArrayBufferView to start reading</param>
        ///<returns type="Number or Object">returns numeric value</returns>

        var n = length + offset;
        var val = 0, shift;
        for (var x = offset; x < n; x++) {
            shift = ((n - (x + 1)) * 8);
            val += view[x] << shift;
        }
        return val;
    };

    WtcpUtil.prototype.addBitrange = function(val, valToAdd, bitLength, lshBytes) {
        ///<summary>Isolates a bit range from value</summary>
        ///<param name="val" type="Number">Value to add to</param>
        ///<param name="valToAdd" type="Number">Value to add</param>
        ///<param name="bitLength" type="Number">Number of bits to write</param>
        ///<param name="numBytes" type="Number">Byte length of value (1 for INT8, 2 for INT16, etc...)</param>
        ///<returns type="Number"></returns>

        if (valToAdd > (Math.pow(2, bitLength) - 1))
            throw `value is too great for the bitLength specified: ${valToAdd} > ${(Math.pow(2, bitLength) - 1)} for bitlength ${bitLength}`;

        valToAdd = valToAdd << (lshBytes * 8);
        val |= valToAdd;

        return val;
    };

    WtcpUtil.prototype.mergeArrayBuffers = function(bufferInfo1, bufferInfo2) {
        ///<summary>Merge two array buffers</summary>
        ///<param name="bufferInfo1" type="Object">{buffer: ArrayBuffer, offset: Int}</param>
        ///<param name="bufferInfo2" type="Object">{buffer: ArrayBuffer, offset: Int}</param>
        ///<returns type="ArrayBuffer"></returns>
        var ta = new Int8Array(bufferInfo1.buffer, bufferInfo1.offset);
        var tb = new Int8Array(bufferInfo2.buffer, bufferInfo2.offset);
        var n = new Int8Array(ta.length + tb.length);
        n.set(ta);
        n.set(tb, (ta.length - bufferInfo1.offset));

        return n.buffer;
    };

    /**
     * bitwise reader for extracting bit ranges from a TypedArray value
     * @param {Number} val - numeric value to extract bit range from 
     * @param {Number} bitPos - bit position to start reading 
     * @param {Number} bitLength - total number of bits to read 
     * @param {Number} numBytes - byte length of value (1 for INT8, 2 for INT16, etc...)
     * @returns {Number} 
     */
    WtcpUtil.prototype.bitReader = function(val, bitPos, bitLength, numBytes) {
        var totalBits = (numBytes * 8) - 1;

        let n = totalBits;

        while (n > bitPos) {
            val = val & ~(1 << n--);
        }
        val = val >>> (bitPos - bitLength) + 1;

        return val;
    };

    WtcpUtil.prototype.parseWtcpHeader = function(offset, data) {
        var int8View = new Uint8Array(data, offset, 4);
        var h = this.byteReader(int8View, 4, 0);
        return {
            version: this.bitReader(h, 31, 3, 4) + 1,
            type: this.bitReader(h, 28, 3, 4),
            sequence: this.bitReader(h, 25, 10, 4),
            payloadLength: this.bitReader(h, 15, 16, 4)
        };
    };

    WtcpUtil.prototype.promiseTimeout = function(ms, promise) {

        // create a promise that rejects in <ms> milliseconds
        
        let timerId; 
        let timedPromise = new Promise((resolve, reject) => 
            {
                 timerId = setTimeout(() => { reject('timeout in ' + ms + ' ms'); }, ms); 
            }); 

        // returns a race between our timeout and the passed in promise

        return Promise.race([timedPromise, promise])
                .then( (result) => { clearTimeout(timerId); 
                                     return result;
                                    })
                .catch((err) => { 
                    console.log("ALERT : race exception : ", err)
                    return err;});
    };

    WtcpUtil.prototype.EndpointFlags = function() {
        this.Moderator = false;
        this.Speaking = false;
        this.Typing = false;
        this.AudioTxMute = false;
        this.TextMute = false;
        this.Unavailable = false;
        this.Visible = false;
        this.AudioRxMute = false;
        this.TxSilence = false;
        this.RxSilence = false;
        this.EmergencyTx = false;
        this.Self = false;
        this.P2P = false;
        this.Gone = false;

        return this;
    };

    WtcpJs.EndpointFlags = WtcpUtil.prototype.EndpointFlags;

    module.exports = new WtcpUtil();
})();
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],8:[function(require,module,exports){
(function (global){(function (){
/// <reference path="/js/libs/wtcp.util.js" />
/// <reference path="/js/libs/wtcp.client.js" />
"use strict";

global.WtcpJs = global.WtcpJs || {};

var util = require('./wtcp.util.js');

(function(wtcp) {

    wtcp.WTCPAudio = function(client, settings) {

        const SMOOTHING = 0.8;
        const FFT_SIZE = 2048;

        var _this = this;
        var context;
        var gainNode;
        var visCanvas;
        var analyser;
        var micStream;
        var microphone, scriptNode, biquadFilter, offlineContext;
        var channelData;
        var sampleRate;
        var downsampleBuffer;
        var audioSamplesStarted = 0;
        var audioSamplesEnded = 0;
        var audioEndTime;
        var times;
        var initStatus = {
            status: 'inprogress',
            message: 'In Progress'
        };
        var micEnabled = false;
        var sendingAudio = false;
        var audioPlaying = false;
        var playerActive = settings.audioPlayerActive;
        var isVisualizing = false;
        var audioQueueTimeout = null;
        var audioQueue = [];
        var audioQueueBufferLength = 0;
        var endAudioSuccess, endAudioFailure;
        this.messageHandlers = {};

        this.getStatus = function getStatus() { return initStatus; }

        // Properties
        Object.defineProperty(this, "MicrophoneEnabled", { get: function() { return micEnabled; } });
        Object.defineProperty(this, "PlayerEnabled", {
            get: function() { return playerActive; },
            set: function (isEnabled) {
                playerActive = isEnabled;

                if (!(playerActive) && audioQueueTimeout) {
                    clearTimeout(audioQueueTimeout);
                    audioQueueTimeout = null;
                }

                util.wtcpDebug(`WtcpAudio.PlayerEnabled: audio player is now ${playerActive ? 'on' : 'off'}`);
            }
        });

        function asFloat(pct) {
            return pct < 0 ? 0 : pct >= 100 ? 1 : pct / 100;
        }

        /* remove this after some testing
        function convertToMono(input) {
            var splitter = context.createChannelSplitter(2);
            var merger = context.createChannelMerger(2);

            input.connect(splitter);
            splitter.connect(merger, 0, 0);
            splitter.connect(merger, 0, 1);
            return merger;
        } */

        function audioBufferSourceNodeEnded(e) {
            if (++audioSamplesEnded === audioSamplesStarted) {
                audioPlaying = false;
                audioSamplesEnded = 0;
                audioSamplesStarted = 0;
            }
        }

        function setGain(val) {
            gainNode.gain.value = asFloat(val);
        }

        function draw() {
            // Draw the time domain chart.
            var bufferLength = analyser.frequencyBinCount;
            var sliceWidth = visCanvas.width * 1.0 / bufferLength;
            var x = 0, v = 0, y = 0;
            var drawCtx = visCanvas.getContext('2d');
            drawCtx.clearRect(0, 0, visCanvas.width, visCanvas.height);
            drawCtx.lineWidth = 2;
            drawCtx.strokeStyle = 'white';
            drawCtx.beginPath();

            analyser.getByteTimeDomainData(times);

            for (var i = 0; i < bufferLength; i++) {
                v = times[i] / 128.0;
                y = v * visCanvas.height / 2;

                if (i === 0)
                    drawCtx.moveTo(x, y);
                else
                    drawCtx.lineTo(x, y);

                x += sliceWidth;
            }

            drawCtx.lineTo(visCanvas.width, visCanvas.height / 2);
            drawCtx.stroke();
        }

        function startAudio(src) {
            audioSamplesStarted++;

            src.connect(gainNode);
            gainNode.connect(isVisualizing ? analyser : context.destination);

            if (!audioPlaying) {
                audioPlaying = true;
                //audioEndTime = context.currentTime + .05;
                audioEndTime = context.currentTime;
            }
            src.start(audioEndTime);
            audioEndTime += (src.buffer.duration);

            if (isVisualizing)
                requestAnimationFrame(draw);
        }

        this.playAudio = function(buffer, audioLength) {
            if (!playerActive)
                return;

            audioQueue.push(buffer);
            audioQueueBufferLength += audioLength;

            if (!audioQueueTimeout) {
                audioQueueTimeout = setTimeout(function() {
                    var data = audioQueue;
                    var len = audioQueueBufferLength;

                    audioQueue = [];
                    audioQueueBufferLength = 0;

                    var src = context.createBufferSource();
                    src.onended = audioBufferSourceNodeEnded;

                    var b = data[0];
                    for (var x = 1; x < data.length; x++) {
                        b = util.mergeArrayBuffers({ buffer: b, offset: 0 }, { buffer: data[x], offset: 0 });
                    }

                    // Experimental feature - trying to decode Opus. Use if (1) to enable
                    if (0) {
                        context.decodeAudioData(buffer, function(data) {
                            src.buffer = data;

                            startAudio(src);
                        }, function(e) { util.wtcpInfo("Error decoding audio", e); });
                    } else {
                        var audioArrayBuffer = context.createBuffer(1, (len / 2), 8000);
                        audioArrayBuffer.copyToChannel(new Float32Array(b), 0);
                        src.buffer = audioArrayBuffer;

                        util.wtcpDebug("Scheduling audio clip: duration = " + src.buffer.duration + ", Queue depth: " + data.length + ", buffer length: " + len);
                        startAudio(src);

                        audioQueueTimeout = null;
                    }
                }, 250);
            }
        };

        this.sendAudio = function() {

            // scriptProcessorNode's dont work on OfflineAudioContexts in chrome. Its not getting fixed
            // because scriptprocessor nodes are going away in favor of Audio Workers, which will work with offlinecontexts
            // Will have to use scriptProcessorNode for now

            if (!sendingAudio && typeof context.createMediaStreamSource === "function") {
                let halting = false;
                sendingAudio = true;

                if (micStream) {

                    microphone = context.createMediaStreamSource(micStream);
                    scriptNode = context.createScriptProcessor(settings.processorNodeBufferSize, 1, 1);
                    biquadFilter = context.createBiquadFilter();
                    biquadFilter.type = 'lowpass';
                    biquadFilter.frequency.value = 4000;
                    biquadFilter.Q.value = 2;

                    scriptNode.onaudioprocess = function(e) {

                        /* ---------------- OfflineAudioContext method of downsampling audio ---------------------------------------- 
                        // This works but you still get clicking artifacts after every sample
                        var b, source;
                        offlineContext = new OfflineAudioContext(1, e.inputBuffer.length / (e.inputBuffer.sampleRate / 8000), 8000);

                        offlineContext.oncomplete = function(audioBuffer) {
                            var buffer = audioBuffer.renderedBuffer.getChannelData(0).buffer;
                                client.SendMessage("processAudio", 1, {
                                    sampleRate: 8000,
                                    channelData: buffer
                                }, [buffer]);
                        };

                        downsampleBuffer = offlineContext.createBuffer(1, e.inputBuffer.length, e.inputBuffer.sampleRate);

                        b = downsampleBuffer.getChannelData(0);
                        e.inputBuffer.copyFromChannel(b, 0);

                        source = offlineContext.createBufferSource();
                        source.buffer = downsampleBuffer;
                        source.connect(offlineContext.destination);
                        source.start(0);

                        offlineContext.startRendering();

                        /* ------------------------------------------------------------------------------------------------------------*/

                        /* ----------------- Pass audio buffer straight to worker thread where it can be manually down-sampled  ------- */

                        sampleRate = e.inputBuffer.sampleRate;
                        channelData = new Float32Array(e.inputBuffer.length);
                        e.inputBuffer.copyFromChannel(channelData, 0);

                        client.SendMessage("processAudio", 1, {
                            sampleRate: sampleRate,
                            channelData: channelData.buffer,
                            flush: !sendingAudio
                        }, [channelData.buffer]);

                        if (!sendingAudio && !halting) {
                            try {
                                client.SendMessage("endAudio", 1);
                                halting = true;
                            } catch (err) {
                                endAudioFailure(err);
                            }
                        }
                        /* -------------------------------------------------------------------------------------------------------------*/
                    }

                    // Due to chrome autoplay policy from Chrome 71, we need to call resume (https://goo.gl/7K7WLu) 
                    context.resume();
                    microphone.connect(biquadFilter);
                    biquadFilter.connect(scriptNode);
                    scriptNode.connect(context.destination);
                }
            }
        };

        this.messageHandlers['audioEnded'] = function() {
            microphone.disconnect();
            biquadFilter.disconnect();
            scriptNode.disconnect();
            util.wtcpDebug('audio: audioEnded handled, disconnected microphone and script node');
            endAudioSuccess();
        };

        this.endAudio = function() {

            return new Promise(function(resolve, reject) {
                if (microphone) {
                    sendingAudio = false;
                    endAudioSuccess = resolve;
                    endAudioFailure = reject;
                } else {
                    resolve();
                }
            });
        };

        this.setVolume = function(val) {
            setGain(val);
        }

        this.visualize = (canvas) => {
            times = new Uint8Array(analyser.frequencyBinCount);
            visCanvas = canvas;
            isVisualizing = true;
        };

        var init = function() {
            util.setLoggingLevel(settings.loggingLevel);
            try {
                // Fix up for prefixing
                window.AudioContext = window.AudioContext || window.webkitAudioContext;
                window.OfflineAudioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
                context = new AudioContext();
                gainNode = context.createGain();
                setGain(settings.initialVolume);
                analyser = context.createAnalyser();
                analyser.minDecibels = -140;
                analyser.maxDecibels = 0;
                analyser.smoothingTimeConstant = SMOOTHING;
                analyser.fftSize = FFT_SIZE;
                analyser.connect(context.destination);
            } catch (e) {
                throw "Initialization error: " + e.message;
            }

            try {
                if (navigator.mediaDevices === undefined) {
                    util.wtcpError("you are not secure running browser.");
                    throw "current DOM is not loaded securely. try to use https instead of http";
                }  
                if (navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({ audio: true })
                        .then(function(stream) {
                            micStream = stream;
                            micEnabled = true;
                            initStatus = {status: 'ready', message: 'Ready'};
                        })
                        .catch(function(err) {
                            util.wtcpError("getUserMedia error", err);
                            initStatus = {status: 'error', message: err.message};
                        });
                } else {
                    navigator.getUserMedia = navigator.getUserMedia ||
                        navigator.webkitGetUserMedia ||
                        navigator.mozGetUserMedia ||
                        navigator.msGetUserMedia;

                        navigator.getUserMedia({ audio: true }, function (stream) {
                                micStream = stream;
                                micEnabled = true;
                                initStatus = { status: 'ready', message: 'Ready' };
                            }, function (err) {
                                util.wtcpError("getUserMedia error: " + err.message);
                                initStatus = { status: 'error', message: err.message };
                            });
                    } 
            } catch (e) {
                throw "getUserMedia() is not supported in your browser";
            }
        }

        init();
    };

    module.exports = wtcp;
})({});
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./wtcp.util.js":7}],9:[function(require,module,exports){
(function () {
  var validator = new RegExp("^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$", "i");

  function gen(count) {
    var out = "";
    for (var i=0; i<count; i++) {
      out += (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return out;
  }

  function Guid(guid) {
    if (!guid) throw new TypeError("Invalid argument; `value` has no value.");
      
    this.value = Guid.EMPTY;
    
    if (guid && guid instanceof Guid) {
      this.value = guid.toString();

    } else if (guid && Object.prototype.toString.call(guid) === "[object String]" && Guid.isGuid(guid)) {
      this.value = guid;
    }
    
    this.equals = function(other) {
      // Comparing string `value` against provided `guid` will auto-call
      // toString on `guid` for comparison
      return Guid.isGuid(other) && this.value == other;
    };

    this.isEmpty = function() {
      return this.value === Guid.EMPTY;
    };
    
    this.toString = function() {
      return this.value;
    };
    
    this.toJSON = function() {
      return this.value;
    };
  };

  Guid.EMPTY = "00000000-0000-0000-0000-000000000000";

  Guid.isGuid = function(value) {
    return value && (value instanceof Guid || validator.test(value.toString()));
  };

  Guid.create = function() {
    return new Guid([gen(2), gen(1), gen(1), gen(1), gen(3)].join("-"));
  };

  Guid.raw = function() {
    return [gen(2), gen(1), gen(1), gen(1), gen(3)].join("-");
  };

  if(typeof module != 'undefined' && module.exports) {
    module.exports = Guid;
  }
  else if (typeof window != 'undefined') {
    window.Guid = Guid;
  }
})();

},{}],10:[function(require,module,exports){
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.2
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.2',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof(define) === FUNC_TYPE && define.amd) {
            define(function () {
                return UAParser;
            });
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);

},{}]},{},[1,7,6,8,5])

